/**
 * Calculator UI Constants
 * Shared constants for UI elements across all calculators
 */

// Loan Term Options
// Used in all calculators with loan terms
export const LOAN_TERM_OPTIONS = [
  { label: '30 years', value: 30 },
  { label: '15 years', value: 15 }
];

// CTA Button Configuration
export const CTA_BUTTON_CONFIG = {
  label: 'CHAT WITH A LOAN OFFICER',
  url: 'https://mortgage.sibcycline.com/jumpstart',
  theme: 'red-outline'
};

// Disclaimer URLs
export const DISCLAIMER_URLS = {
  findLoanOfficer: 'https://mortgage.sibcycline.com/findloanofficer',
  mortgageHomepage: 'https://mortgage.sibcycline.com/'
};

// Calculator Display Names
export const CALCULATOR_NAMES = {
  MORTGAGE: 'Mortgage Calculator',
  AFFORDABILITY: 'Home Affordability Calculator',
  REFINANCE: 'Refinance Calculator',
  RENT_VS_BUY: 'Rent vs Buy Calculator'
};

// Default Values
export const DEFAULT_VALUES = {
  homePrice: 500000,
  downPaymentPercent: {
    conventional: 20,
    fha: 3.5,
    va: 0
  },
  interestRate: 6.42,
  loanTerm: 30,
  creditScore: 700,
  monthlyIncome: 5000
};

// Validation Limits
export const VALIDATION_LIMITS = {
  interestRate: {
    min: 0,
    max: 100
  },
  downPaymentPercent: {
    min: 0,
    max: 100
  },
  homePrice: {
    min: 0,
    max: 100000000 // 100 million
  }
};

export default {
  LOAN_TERM_OPTIONS,
  CTA_BUTTON_CONFIG,
  DISCLAIMER_URLS,
  CALCULATOR_NAMES,
  DEFAULT_VALUES,
  VALIDATION_LIMITS
};
